export default {
  header: 'Export Your Trip History',
  subtitle:
    'Export your team bookings by selecting a date range below and click download.',
  startDatePlaceholder: 'Start date',
  endDatePlaceholder: 'End date',
  downloadReportButton: 'Download',
};
